import { Phone, MessageCircle, Mail, MapPin } from "lucide-react";
import { toTelDigits } from "../lib/phone";

export const CTAFooter = ({ phone, whatsapp, email }) => {
  return (
    <>
      <section
        data-testid="final-cta-section"
        className="bg-blue-600 py-20 md:py-28"
      >
        <div className="max-w-5xl mx-auto px-6 md:px-12 text-center">
          <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-white">
            One call.
            <br />
            Could change everything.
          </h2>
          <p className="mt-6 text-lg md:text-xl text-blue-100 max-w-2xl mx-auto">
            Recruiters are standing by. Get hired this week. Train next week.
            Earn the week after.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3 justify-center">
            <a
              data-testid="final-call-cta"
              href={`tel:${toTelDigits(phone)}`}
              className="inline-flex items-center justify-center gap-2 bg-slate-900 hover:bg-black text-white font-semibold px-7 py-4 rounded-md transition-all hover:-translate-y-0.5"
            >
              <Phone className="w-5 h-5" />
              Call {phone}
            </a>
            <a
              data-testid="final-whatsapp-cta"
              href={`https://wa.me/${toTelDigits(whatsapp)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-white hover:bg-slate-100 text-slate-900 font-semibold px-7 py-4 rounded-md transition-all hover:-translate-y-0.5"
            >
              <MessageCircle className="w-5 h-5" />
              WhatsApp Now
            </a>
          </div>
        </div>
      </section>

      <footer
        data-testid="site-footer"
        className="bg-slate-900 text-slate-300 py-16"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="inline-flex items-center bg-white rounded-md p-3">
              <img
                src="/knockwave-logo.png"
                alt="Knockwave Telecom"
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="mt-5 text-slate-400 leading-relaxed max-w-md">
              The door-to-door residential sales team for a leading nationwide
              telecom provider. We hire driven reps, train them right, and pay
              them well.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="font-heading text-white font-semibold mb-4">
              Get in touch
            </p>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-blue-400 shrink-0" />
                <a
                  href={`tel:${toTelDigits(phone)}`}
                  data-testid="footer-phone"
                  className="hover:text-white"
                >
                  {phone}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle className="w-4 h-4 text-blue-400 shrink-0" />
                <a
                  href={`https://wa.me/${toTelDigits(whatsapp)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp"
                  className="hover:text-white"
                >
                  WhatsApp Recruiter
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-blue-400 shrink-0" />
                <a
                  href={`mailto:${email}`}
                  data-testid="footer-email"
                  className="hover:text-white"
                >
                  {email}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <MapPin className="w-4 h-4 text-blue-400 shrink-0" />
                <span>Hiring nationwide</span>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="font-heading text-white font-semibold mb-4">
              Quick links
            </p>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#benefits" className="hover:text-white">
                  Why Knockwave
                </a>
              </li>
              <li>
                <a href="#process" className="hover:text-white">
                  Application process
                </a>
              </li>
              <li>
                <a href="#earnings" className="hover:text-white">
                  Earnings potential
                </a>
              </li>
              <li>
                <a href="#faq" className="hover:text-white">
                  FAQ
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-800 max-w-7xl mx-auto px-6 md:px-12 flex flex-col sm:flex-row justify-between gap-4 text-xs text-slate-500">
          <p>
            © {new Date().getFullYear()} Knockwave Telecom. All rights reserved.
          </p>
          <p>Authorized retail partner of a leading telecom provider.</p>
        </div>
      </footer>
    </>
  );
};
